<template>
    <base-layers-tree-item v-if="!hideWrapper" :item="item">
        <div class="layer-row pl-2">
            <div class="grow-1 d-flex items-center">
                <div class="action cursor-pointer no-drag" @click.prevent.capture="onCollapseClick()">
                    <font-awesome-icon v-if="collapsed" class="mr-1 action-icon" :icon="['fas', 'chevron-down']" />
                    <font-awesome-icon v-else class="mr-1 action-icon" :icon="['fas', 'chevron-right']" />
                </div>
                <div class="icon element-icon mr-2">
                    <font-awesome-icon class="mr-1 status-icon" :icon="['fas', 'file']" />
                </div>
                <div class="layers-element-title grow-1">
                    <editable-text
                        :value="item.element.name"
                        :default-text="item.element.name"
                        :allow-editing="flags?.enableEditTitlePageEps"
                        @input="onElementTitleChange"
                    />
                </div>
            </div>
        </div>
    </base-layers-tree-item>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import store from '@/store';
import EditableText from '@/components/EditableText/EditableText.vue';
import BaseLayersTreeItem from '../BaseLayersTreeItem.vue';
import type { ListElements } from '@/typings/customilyElements/layer';
import { useLayerTreeItem } from '@/components/Layers/composables/useLayerTreeItem';

const emit = defineEmits(['toggle-collapse']);

const props = defineProps<{
    item: ListElements;
    collapsed?: boolean;
}>();

const { flags, onElementTitleChange } = useLayerTreeItem({
    item: props.item
});

const pageEpsElements = computed(() => {
    return store.state.storeLayers?.rawElements.pageEpsElements;
});

const hideWrapper = computed(() => {
    return pageEpsElements.value && pageEpsElements.value?.length <= 1;
});

const onCollapseClick = () => {
    emit('toggle-collapse');
};
</script>

<style lang="scss" scoped>
.action-icon {
    fill: var(--secondary-color);

    &.selected {
        fill: #000;
    }
}
.status-icon {
    fill: var(--primary-blue);
    color: var(--primary-blue);

    &.selected {
        fill: #000;
        color: #000;
    }
}
:deep(.layers-element-title .editable-div span) {
    padding-right: 4px;
}
</style>
